import * as React from "react";

import hanafye from "../../assets/7anafye.png";
import water from "../../assets/water.png";
import plant from "../../assets/plant.png";
import {
  HelpBadge,
  HelpBageBottom,
  HelpBageTop,
  HelpCard,
  HelpCards,
  HelpContainer,
  HelpHeader,
  HelpMainContainer,
  HelpSection,
  HelpSectionCard,
  HelpSectionCards,
} from "./Help.styled";
import { MiniNav } from "../MoveIn.screen/MoveIn.styled";
import { NavLink } from "../FAQ/FAQ.styled";
import General from "../../stores/GeneralStore";
const HelpCenter = () => {
  return (
    <>
      <HelpHeader>
        <div style={{ width: "90%", margin: "0 auto" }}>
          <MiniNav>
            <NavLink to="">{General?.codeLabels["cm_home"]?.label !== undefined ? General?.codeLabels["cm_home"]?.label : " Home"}</NavLink>
            &nbsp;/&nbsp;
            <NavLink to="/">
              {General?.codeLabels["cm_sustainability"]?.label !== undefined ? General?.codeLabels["cm_sustainability"]?.label : "Sustainability"}
            </NavLink>
            &nbsp;/&nbsp;
            <NavLink to="/">How Can You Help?</NavLink>
          </MiniNav>
          <h1 style={{ color: "#fff" }}>How Can You Help?</h1>
        </div>
        <HelpBadge>
          <HelpBageTop>
            Although we hope to implement various systems in households and
            workplaces throughout Ajman that can help reduce the use of water on
            a daily basis, saving water starts with you!
          </HelpBageTop>
          <HelpBageBottom>
            Every little bit will help us achieve a more sustainable world to
            live in. Doing so is very easy, all it takes are a few small changes
            in a and around the house to make a difference Once you learn that
            water is very valuable and scarce, you realize how it can have an
            effect on the environment around us. Each individual has a part to
            play to ensure that the environment is kept safe for years to come.
            Here are some tips below on how you can save this precious resource
          </HelpBageBottom>
        </HelpBadge>
      </HelpHeader>
      <HelpMainContainer>
        <HelpContainer>
          <HelpCards>
            <HelpCard>
              <img src={hanafye} alt="" />
              <p>
                <p>
                  <b>Inside the Home</b>
                </p>
                Groundwater is exactly what it is, water that is located
                underground between rock sediments called aquifers. Over time,
                water enters the ground and is stored between soil pre spaces
                and gaps in rock formations. These massive, natural containers
                can – if used sparingly and efficiently – provide a significant
                amount of potable water to use in many ways. Aquifers are
                usually formed as part of a large system spanning a wide area
                and are found across the UAE and even cross-borders.
                <br />
                <br />
                However, overexploitation of these aquifers is becoming an
                increasing worry for countries around the world and especially
                ones here in the Middle East where water demand is outpacing
                supply in some areas. For example, in Abu Dhabi, groundwater
                sources are being used at more than 15 times the rate at which
                they can be replenished. This means that water that has been
                stored up to 10,000 years ago will have completely vanished.
                <br />
                <br />
                Even more worrying is what happens to the empty aquifers after
                the water is depleted. If they are not re-filled or filled in,
                saltwater intrusion can take place. This is where salt water
                from the coast gradually seeps in to the aquifers and makes the
                salinity levels of the sail increase. This can affect the local
                area and make it impossible for crops and other vegetation to
                grow properly.
              </p>
            </HelpCard>
            <HelpCard>
              <img src={plant} alt="plant" />
              <p>
                <p>
                  <b>Outside the Home</b>
                </p>
                Modern technology has allowed us to harness the abundance of
                perviously unusable water sources. Once though unusable,
                seawater can now be used as an effective source of potable and
                drinking water for the whole population to enjoy. In fact, 40%
                of the water used in the UAE comes from desalination.
                <br />
                <br />
                The process used desalination plants is called “Reverse
                Osmosis”, where a semi-permeable membrane is used to separate
                the salts from the water. Over the years, this has developed to
                a convenient way of creating large volumes of water over a
                period of time.
                <br />
                <br />
                Despite providing a great source of potable water, desalination
                comes with a hefty toll. The process can be very costly, not
                only in monetary terms but directly to the environment as well.
                The entire process is energy intensive, which is negatively
                contributing to our environment by adding excess carbon dioxide
                emissions to the atmosphere which in turn contributes to global
                warming. In addition to this, the natural ecosystem of the
                surrounding ocean is usually affected by such industrial water
                treatment.
              </p>
            </HelpCard>
          </HelpCards>
        </HelpContainer>
        <HelpSection>
          <img src={water} alt="water" />
          <HelpSectionCards>
            <HelpSectionCard>
              <h3>Let’s Recycle Water, Together</h3>
              <span>
                The UAE has one of the highest water consumption rates in the
                world, with each person on average using 550 litres of water per
                day. Total annual water demand is predicted to be at 8.8 billion
                cubic metres by 2030, almost double what is consumed today.
                <br />
                <br />
                This growth has to be slowed down if we want to become a society
                that is at the forefront of global environment recognition and
                development. Instead of using more water from irreplaceable
                sources, why not use what we have already in a safe and clean
                way thanks to high standards water treatment?
                <br />
                <br />
                Water recycling can do a lot to preserve the environment and
                help us achieve our future developmental goals: it can be used
                in residential and recreational applications, green spaces
                community-building opportunities, and commercial-industrial
                purposes. In a nutshell, supporting water recycling means
                supporting the urban development and the economic growth
                dispatch our highly trained engineers to oversee the system on a
                daily basis.
              </span>
            </HelpSectionCard>
            <HelpSectionCard>
              <h3>Water Recycling and Reuse</h3>
              <span>
                Currently, one third of the water that we treat is re-used to
                irrigate various areas in the Emirate of Ajman or is treated
                further to be utilized for particular practical commercial and
                industrial applications.
                <br />
                <br />
                We aim to make recycled water the norm throughout the Emirate of
                Ajman, and want the general public to accept that recycled used
                water is one of the best sources for sustainable water use
                available. We want the people of Ajman and the UAE to be more
                open to the notion that once used, water can be re-used.
                <br />
                <br />
                Reducing the need for expensive methods of water will allow to
                focus on other social development projects to improve further
                the lives of those living or working in the Emirate. We
                therefore continue to expand our used water recycling
                capabilities of all tankers discharge at the dedicated tanker
                discharge facility at our treatment plant.
              </span>
            </HelpSectionCard>
          </HelpSectionCards>
        </HelpSection>
      </HelpMainContainer>
    </>
  );
};

export default HelpCenter;
